import { TListResponse } from 'src/common/types';
import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';
import { TUserMeta, TUserMetaResponse, adaptUserMetaUndefinedFromResponse } from './user-meta.type';


export const ProviderListSortCol = {
	NAME: 'name',
	UPDATED_AT: 'updated_at',
	CREATED_AT: 'created_at',
};

export type TProviderListSortCol = TTableSortCols<typeof ProviderListSortCol>;

export type TProviderListQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TProviderListSortCol;
};

export type TProviderListQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptProviderListQueryToRequest(data?: TProviderListQuery): TProviderListQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TProvider = {
  id: number;
  name: string;
  description?: string;
  url: string;
  path: string;
  isActive: boolean;
	createdAt: string;
  updatedAt: string;

	createdBy?: TUserMeta;
	updatedBy?: TUserMeta;
};

export type TProviderResponse = {
  id: number;
  name: string;
  description?: string;
  url: string;
  path: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;

	created_by?: TUserMetaResponse;
	updated_by?: TUserMetaResponse;
};

export type TProviderListResponse = TListResponse<TProviderResponse>;

export type TProviderList = TListResponse<TProvider>;

export type TProviderPayloadRequest = {
	name: string;
	description?: string;
  url: string;
  path: string;
  isActive: boolean;
};

export type TProviderRequest = {
	name: string;
	description?: string;
  url: string;
  path: string;
  is_active: boolean;
};

export type TProviderPayloadUpdate = {
	id: number;
	data: TProviderPayloadRequest;
};

export function adaptProviderFromListResponse(data: TProviderListResponse): TProviderList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptProviderFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptProviderFromResponse(data: TProviderResponse): TProvider {
	const {
		id,
		name,
		description,
		url,
		path,
		is_active: isActive,
		created_at: createdAt,
		updated_at: updatedAt,
		created_by: createdByRaw,
		updated_by: updatedByRaw,
	} = data;

	const createdBy = adaptUserMetaUndefinedFromResponse(createdByRaw);
	const updatedBy = adaptUserMetaUndefinedFromResponse(updatedByRaw);

	return {
		id,
		name,
		description,
		url,
		path,
		isActive,
		createdAt,
		updatedAt,
		createdBy,
		updatedBy,
	};
}

export function adaptProviderToRequest(data: TProviderPayloadRequest): TProviderRequest {
	const {
		name,
		description = undefined,
		url,
		path,
		isActive,
	} = data;

	return {
		name,
		description,
		url,
		path,
		is_active: isActive,
	};
}
